import { render, staticRenderFns } from "./UserNav.vue?vue&type=template&id=6167900c"
import script from "./UserNav.vue?vue&type=script&lang=js"
export * from "./UserNav.vue?vue&type=script&lang=js"
import style0 from "./UserNav.vue?vue&type=style&index=0&id=6167900c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports